import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { CareElementFrequencyType } from "../CareElementFrequencyType";
import { BaseCareElementConfig } from "./BaseCareElementConfig";

export class FrequencyCareElementConfig extends BaseCareElementConfig {
    public Frequency?: CareElementFrequencyType;

    public constructor(init: NonFunctionProperties<FrequencyCareElementConfig>) {
        super(init);
        this.Frequency = init.Frequency;
    }
}
